interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'className'> {
  label?: string;
  options: SelectOption[];
  fullWidth?: boolean;
  className?: string;
}

export function Select({ label, options, fullWidth, id, className = '', ...props }: SelectProps) {
  const selectId = id ?? `select-${Math.random().toString(36).slice(2)}`;
  return (
    <div className={`form__field ${fullWidth ? 'form__field_full' : ''}`}>
      {label && (
        <label htmlFor={selectId} className="form__label">
          {label}
        </label>
      )}
      <select id={selectId} className={`form__input ${className}`} {...props}>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
